import React from 'react';
import Menu from '../../assets/icons/menu.svg';
import Close from '../../assets/icons/close-menu.svg';
import { Trans } from 'react-i18next'

export default React.memo(({ open, ...props }) => {
  return (
    <button className="menu-toggle" {...props}>
      <span>
        <Menu />
        <span className="sr-only">Menu</span>
      </span>
      <span>
        <Close />
        <span><Trans i18nKey="navigation.close">Sluit</Trans></span>
      </span>
    </button>
  );
});
